
































import { dateService } from '@/services';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class WizardStoreUpdateHistory extends Vue {
  @Prop({ default: false }) open: boolean;
  @Prop({ required: true }) store: any;
  public parseDateToString = dateService.parseDateToString;

  @Emit('close')
  onClose () {} // tslint:disable-line
}
